export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isFocus: false
    }
  },
  methods: {
    setFocus (isFocus) {
      this.isFocus = isFocus
      this.$emit(isFocus ? 'focus' : 'blur')
    },
    toggleFocus () {
      this.isFocus ? this.blur() : this.focus()
    },
    handlerClick (event) {
      this.$emit('click', event)
    }
  }
}
